import React from 'react';
import QRCode from 'react-qr-code';
import { QrCode as QrCodeIcon } from 'lucide-react';

const QRCodeDisplay = ({ 
  address, 
  size = 140, 
  notConfiguredText = 'Not configured' 
}) => {
  if (address && address !== 'Not configured') {
    return (
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '12px',
        display: 'inline-block',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}>
        <QRCode
          value={address}
          size={size}
          level="H"
          fgColor="#000000"
          bgColor="#ffffff"
          style={{ display: 'block' }}
        />
      </div>
    );
  }

  return (
    <div style={{
      width: `${size}px`,
      height: `${size}px`,
      backgroundColor: '#2b3139',
      borderRadius: '12px',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '8px',
    }}>
      <QrCodeIcon size={48} color="#474d57" />
      <span style={{ fontSize: '11px', color: '#848e9c' }}>{notConfiguredText}</span>
    </div>
  );
};

export default QRCodeDisplay;
